import { Avatar } from '@/components/Avatar';
import { LinkableCard } from '@/components/Custom/Card/LinkableCard';
import { InfoWithIcon } from '../InfoWithIcon';
import { TFunction } from 'i18next';

interface SubscribedGroupCardProps {
  t: TFunction<undefined>;
  linkTo?: string;
  avatarUrl?: string;
  groupName: string;
  description?: string;
  registrationEndDate: string;
}

export const SubscribedGroupCard = ({
  t,
  linkTo,
  avatarUrl,
  groupName,
  registrationEndDate,
}: SubscribedGroupCardProps) => {
  return (
    <LinkableCard
      linkTo={linkTo}
      containerClassName="flex-row flex-wrap items-center gap-x-3"
    >
      <div className="flex items-center gap-3 max-sm:w-full">
        <Avatar
          imageUrl={avatarUrl}
          // containerClassName="w-[35px] h-[35px] rounded-full border border-gray-600 shadow-0 [&_.profile-image-wrapper]:border-white [&_img]:object-cover [&_img]:mt-0"
          containerClassName="w-[35px] h-[35px] rounded-full border border-gray-600 shadow-0 [&_.profile-image-wrapper]:border-white max-[1450px]:w-[45px] max-[1450px]:h-[45px]"
        />
        <div className="hidden text-sm text-gray-5D5D5D font-semibold max-sm:block">
          {groupName}
        </div>
      </div>
      <div className="flex flex-1 flex-col -space-y-[13px] max-sm:mt-0.75 max-sm:space-y-0 max-[360px]:mt-2">
        <div className="text-sm text-gray-5D5D5D font-semibold max-sm:hidden">
          {groupName}
        </div>
        <div className="flex flex-wrap justify-between items-end gap-3 max-sm:items-center max-sm:gap-1.5">
          <div className="text-2sm text-gray-5D5D5D font-thin">
            {`${t('common:subscriptionEndDate')} :`}
          </div>
          <InfoWithIcon
            containerClassName="bg-blue-EAEFFF px-3.5 pt-1.75 pb-1.5 rounded-md gap-1.75"
            textClassName="text-xs text-gray-5D5D5D"
            icon={<i className="-mt-0.5 ki-outline ki-calendar text-sm" />}
            text={registrationEndDate}
          />
        </div>
      </div>
    </LinkableCard>
  );
};
